const oliveA = {
  oliveA1: "hsla(120, 89.3%, 18.3%, 0.012)",
  oliveA2: "hsla(120, 87.7%, 16.0%, 0.028)",
  oliveA3: "hsla(120, 99.5%, 7.7%, 0.051)",
  oliveA4: "hsla(120, 92.3%, 8.5%, 0.075)",
  oliveA5: "hsla(120, 86.0%, 6.9%, 0.099)",
  oliveA6: "hsla(120, 94.8%, 6.8%, 0.122)",
  oliveA7: "hsla(120, 99.3%, 5.2%, 0.153)",
  oliveA8: "hsla(110, 93.8%, 5.2%, 0.240)",
  oliveA9: "hsla(111, 98.7%, 3.0%, 0.459)",
  oliveA10: "hsla(111, 93.5%, 2.9%, 0.499)",
  oliveA11: "hsla(111, 95.2%, 2.5%, 0.585)",
  oliveA12: "hsla(110, 97.6%, 2.6%, 0.930)"
};
export { oliveA };
//# sourceMappingURL=oliveA.mjs.map
